import axios from 'axios'; // 引入axios
import axiosRetry from 'axios-retry' 

const baseURL = 'http://game.hotplaygames.com'
axios.defaults.timeout = 10000
axios.defaults.baseURL = baseURL //填写域名

let time = 3

axiosRetry(axios, {
  retries: time,                       // 设置自动发送请求次数
  retryDelay: (retryCount) => {
    return retryCount * 1000;      // 重复请求延迟
  },
  shouldResetTimeout: true,       //  重置超时时间true
  retryCondition: (error) => {
    //true为打开自动发送请求，false为关闭自动发送请求
    if (time-- > 0) {
      return true
    } else {
      return false
    }
  }
});

axios.interceptors.request.use(
  config => {
    config.data = config.data;
    config.headers = {
      'Content-Type':'application/x-www-form-urlencoded'
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

//响应拦截器即异常处理
axios.interceptors.response.use(response => {
  time = 3
  // let testUrl = ['/search','/details']
  // let index = testUrl.findIndex(item => item.indexOf(location.pathname))
  // 搜索页和详情页单独处理
  // if (index >= 0) {
  //   if (response.data.msg == "no data") {
  //     return location.href = '/errorPage'
  //   }
  // }
  return response
}, err => {
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
          console.log('400 错误请求')
        break;
      case 401:
          console.log('401 未授权，请重新登录')
        break;
      case 403:
        console.log('403 拒绝访问')
        break;
      case 404:
        console.log('404 请求错误,未找到该资源')
        break;
      case 405:
        console.log('405 请求方法未允许')
        break;
      case 408:
        console.log('408 请求超时')
        break;
      case 500:
        console.log('500 服务器端出错')
        break;
      case 501:
        console.log('501 网络未实现')
        break;
      case 502:
        console.log('502 网络错误')
        break;
      case 503:
        console.log('503 服务不可用')
        break;
      case 504:
        console.log('504 网络超时')
        break;
      case 505:
        console.log('505 http版本不支持该请求')
        break;
      default:
        console.log(`连接错误${err.response.status}`)
    }
  } else {
    console.log('连接到服务器失败')
    // post('https://data.hotplaygames.com/index.php', { msg: '错误信息，直接传一行文本就行了'})
  }
  return Promise.resolve(err.response)
})

export function fetch(url, params = {}){
  return new Promise((resolve,reject) => {
    axios.get(url, {
      params:params
    })
    .then(response => {
      resolve(response.data);
    })
    .catch(err => {
      reject(err)
    })
  })
}

export function post(url, data = {}){
  return new Promise((resolve, reject) => {
    axios.post(url, data)
         .then(response => {
           resolve(response.data);
         },err => {
           reject(err)
         })
  })
}

export function patch(url, data = {}){
  return new Promise((resolve,reject) => {
    axios.patch(url, data)
         .then(response => {
           resolve(response.data);
         },err => {
           reject(err)
         })
  })
}

export function put(url, data = {}){
  return new Promise((resolve,reject) => {
    axios.put(url, data)
         .then(response => {
           resolve(response.data);
         },err => {
           reject(err)
         })
  })
}

export function downLoad(url, params = {}, header){
  return new Promise((resolve,reject) => {
    axios.post(url, params, header)
    .then(response => {
      resolve(response.data);
    })
    .catch(err => {
      reject(err)
    })
  })
}


// WEBPACK FOOTER //
// ./src/util/api.js